import {Injectable} from '@angular/core';
import {ContractDetailsModel} from '@cc-commons/models/contract-details.model';

@Injectable()
export class TempManageReportsService {
	contractDetails: ContractDetailsModel;
}
